export enum STEP_PROGRESS {
  ITEM = "stepProgressItem",
  ITEM_VISITED = "stepProgressItemVisited",
  ITEM_COMPLETED = "stepProgressItemCompleted",
  CHECK = "stepProgressCheck",
}
